
/* ============
 * Vue
 * ============
 *
 * Vue.js is a library for building interactive web interfaces.
 * It provides data-reactive components with a simple and flexible API.
 *
 * http://rc.vuejs.org/guide/
 */
import Vue from 'vue';

/* ============
 * Vuex Router Sync
 * ============
 *
 * Effortlessly keep vue-Router and vuex store in sync.
 *
 * https://github.com/vuejs/vuex-router-sync/blob/master/README.md
 */
import VuexRouterSync from 'vuex-router-sync';
import store from './store';
import router from './routes';


/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */
// import VueI18n from 'vue-i18n';
// import messages from './locale';

// Vue.use(VueI18n);

// export const i18n = new VueI18n({
//   locale: 'en',
//   fallbackLocale: 'en',
//   messages,
// });


/* ============
 * jQuery
 * ============
 *
 * Require jQuery
 *
 * http://jquery.com/
 */
// import jQuery from 'jquery';

// window.$ = window.jQuery = jQuery;


// 引入公共样式
import '@/styles/index.less';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// Sentry.init({
//   // 开发环境下无process.env.RELEASE
//   debug: !process.env.RELEASE,
//   // 创建项目时，生成的DSN（可在 项目配置 下再次找到DSN）
//   // 例：https://e53c7938d4e14389ac185b92fab41967@sentry.guahao.cn/42
//   dsn: 'https://999d84fac2634941bcc310accac02fcc@sentry.guahao.cn/63',
//   // build时，自动生成process.env.RELEASE
//   release: process.env.RELEASE,
//   environment: process.env.NODE_ENV,
// });
// // 将Sentry对象绑定到window对象下，方便其他组件调用（可选）
// window.Sentry = Sentry;

import moment from 'moment';


import lodash from 'lodash';

Vue.config.debug = process.env.NODE_ENV !== 'production';

VuexRouterSync.sync(store, router);

// sentry
// import * as Sentry from 'sentry-browser';

Vue.use(ElementUI);


Vue.prototype.$moment = moment;

Vue.prototype.$_ = lodash;
